import classNames from 'classnames';
import Package from './package';
import { PackageType } from '../../api/package';

export type PackageListPropsType = {
  packages: PackageType[];
  className: string;
};

function PackageList({ packages, className }: PackageListPropsType) {
  return (
    <div
      className={classNames(
        '2lg:grid-cols-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3',
        { [className]: className }
      )}
    >
      {packages.map(pkg => (
        <Package key={pkg.id} packageData={pkg} />
      ))}
    </div>
  );
}

export default PackageList;
